import { render } from "./AddEmailDialog.vue?vue&type=template&id=450a8606&ts=true"
import script from "./AddEmailDialog.vue?vue&type=script&lang=ts"
export * from "./AddEmailDialog.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__